import React from 'react'

export const CollectionContext = React.createContext(null)

export const TieredCollectionContext = React.createContext(null)